import { defineStore } from 'pinia'
import Actions from './actions'
import Getters from './getters'
import { useState } from './state'

export { type CabinState } from './state'

export const useCabinStore = defineStore('cabin', {
  state: useState,
  getters: { ...Getters },
  actions: { ...Actions },
})

export type CabinStoreContext = ReturnType<typeof useCabinStore>